import React from "react";
import "./Buttons.css";
import { useTranslation } from "react-i18next";
import googlePlayIcon from "../../assets/images/google-play-store-icon.png";
const DownloadOnGooglePlay = () => {
  const { t } = useTranslation();
  return (
    <a href="##" className="main-download-button">
      <div className="mobile-button-flex">
        <div className="download-icon-mobile">
          <img src={googlePlayIcon} alt="Google Play Icon" />
        </div>
        <div className="download-text-mobile">
          <p>
            {t("Download")} {t("on")}
          </p>
          <h5>Play Store</h5>
        </div>
      </div>
    </a>
  );
};

export default DownloadOnGooglePlay;
